<template>
    <span>
        <span v-if="sdkLoaded || textLink">
            <v-btn class="text-white login-facebook" :loading="loading" v-if="!textLink"  @click="logInWithFacebook" block large color="#4568b2" >
                   <v-icon left>fab fa-facebook-f</v-icon>
                   {{ textBtn }}
            </v-btn>
            <a v-else href="#" @click="logInWithFacebook">{{textLink}}</a>
        </span>
    </span>
</template>

<script>
    import Toolbox from "@/shared/toolbox";

    import {sendAuth} from '../auth';

    export default {
        props: {
            appId: {
                default: null
            },
            textLink: {
                default: null
            },
            textBtn: {
                default: 'Log in with Facebook'
            }
        },
        mixins: [sendAuth],
        name: "FacebookBtn",
        data: () => ({
            facebookUser: null,
            id: true,
            sdkLoaded: false,
            loading: false,
        }),
        created() {
            if (typeof global.FB === 'object') {
                this.sdkLoaded = true;
            } else {
                this.loadFacebookSDK(document, "script", "facebook-jssdk");
            }
        },
        methods: {
            logInWithFacebook() {
                this.loading = true;

                window.FB.login(response => {
                    if (response.authResponse) {
                        this.facebookUser = {
                            token: response.authResponse.accessToken,
                            userID: response.authResponse.userID
                        };

                        this.sendLoginSocial(this.facebookUser, '/login/facebook', (response) => {
                            if (response.id) {
                                this.$emit('loggedIn');
                            } else if (response?.error) {
                                Toolbox.error(response?.error);
                            } else {
                                this.id = false;
                                this.$emit('registry', false);
                                this.$emit('registryData', response.data);

                                this.loading = false;
                            }
                        });
                    } else {
                        console.debug("User cancelled login or did not fully authorize.");
                        this.loading = false;
                    }
                });

                return false;
            },

            loadFacebookSDK(d, s, id) {
                window.fbAsyncInit = () => {
                    this.sdkLoaded = true;
                };

                var js,
                    fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) {
                    return;
                }
                js = d.createElement(s);
                js.id = id;
                js.src = "https://connect.facebook.net/en_US/sdk.js#xfbml=1&cookie=1&version=v2.9&appId="+this.appId;
                fjs.parentNode.insertBefore(js, fjs);
            }
        },
        emits: ['loggedIn'],
    }
</script>
